import { Injectable, inject } from '@angular/core';
import { of } from 'rxjs';
import { featureConfig } from '../interfaces';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly _apiPath = 'users';
  private readonly _api = inject(ApiService);

  getUserFeatureFlags() {
    // Mock Feature Flags
    // TODO: Load these from the backend in the future
    const featureFlags: featureConfig = {
      production: undefined,
      SPC: undefined,
      support: undefined,
      newFipLogo: undefined,
      alerting: undefined,
      calibration: undefined,
      'article-mapping': undefined,
    };
    return of({ data: featureFlags });
    // return this._api.get<featureConfig>(`${this._apiPath}/${userId}/roles`);
  }
}
